import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import PendingApproval from "@/pages/PendingApproval";
import { isUserActive } from "@/lib/userStatus";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--text-muted)] font-mono text-sm" data-testid="loading-screen">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-[var(--gold)] animate-pulse" />
          INICIANDO LSC/EGN…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Gate canônico: bloqueia TODOS os status que não sejam "ativo" / "approved".
  // Cobre: pendente / Pendente / pending_approval / rejeitado / inativo / suspenso.
  if (!isUserActive(user)) {
    return <PendingApproval />;
  }
  if (roles && roles.length && !roles.includes(user.perfil) && user.perfil !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
